import { Component, HostListener } from '@angular/core';
import { Headers, Http, RequestOptions, ResponseContentType } from '@angular/http';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Lightbox } from 'ngx-lightbox';
import { of } from 'rxjs';
import { NewVersionService } from './services/new-version.service';

declare var $: any;

@Component({
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.css']
})
export class DetailsComponent {
  continentFriendlyUrl: string = "europe";
  continent: any = null;
  lists: any = null;
  listTypes: any[] = [];
  languages: any[] = [];
  data: any = null;
  listRestaurants: any = null;
  selectedListId: number = 0;
  selectedList: any = null;
  selectedLanguage: any = {};
  cardViewSelected: boolean = true;

  webProjectPath: string;
  yearFilter: any = [
  
  ];
  selectedYear = 2019;

  sortByFilter: any = [
    { value: 1, displayName: "Rank", urlValue: 'rank' },
    { value: 2, displayName: "Restaurant", urlValue: 'restaurant'},
    { value: 3, displayName: "Chef", urlValue: 'chef'},
    { value: 4, displayName: "Cuisine", urlValue: 'cuisine' },
    //{ value: 5, displayName: "Location", urlValue: 'location' },
    //{ value: 6, displayName: "City", urlValue: 'city' },
    //{ value: 7, displayName: "Country", urlValue: 'country' },
    
  ];
  selectedSortByFilter = 1;
  listTypeFriendlyUrl = 'top100';
  listType: any = null;
  sortByDirection: string = 'ASC'
  mobile = false;
  previewGuid: any = null;
  constructor(private _http: Http,
    private router: Router,
    private _lightbox: Lightbox,
    private route: ActivatedRoute,
    private newVersionService: NewVersionService) {

  }



  @HostListener('window:resize', ['$event'])
  onResize(event) {
    var $tabNavSlider = $('.tabs .tabs__nav ul');
    var $win = $(window);
    var tabNavSliderOptions = {
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      autoplay: false,
      speed: 500,
      variableWidth: true
    };

    if ($win.width() < 768) {
      this.mobile = true;
      this.initSlider($tabNavSlider, tabNavSliderOptions);
      $tabNavSlider.find('.slick-slide').on('click', function (event) {
        var $thisSlide = $(this);
        var thisIndex = $thisSlide.attr('data-slick-index');
        var $thisParent = $thisSlide.closest('.section-slider ul');
        var activeSlides = $thisParent.find('.slick-active').length;
        var goToSlide = thisIndex - activeSlides - 1;
        $tabNavSlider.slick('slickGoTo', goToSlide);
      });
    } else if ($win.width() > 767) {
      this.mobile = false;
      this.destroySlider($tabNavSlider);
    }
  }

  initSlider($selector, options) {
    if ($selector.length && !$selector.hasClass('slick-initialized')) {
      $selector.slick(options);
    }
  }

  destroySlider($selector) {
    if ($selector.length && $selector.hasClass('slick-initialized')) {
      $selector.slick('unslick');
    }
  }

  open(src): void {
    // open lightbox
    //var albums = [
    //  {
    //    src: src.replace("82-102", "original"),
    //    thumb: src
    //  }];

    //this._lightbox.open(albums, 0);
  }

  

  ngOnInit() {

    //since this is hard-coded and so can't be routed as "year" param from app-routing, this is a workaround
    this.selectedYear = parseInt(this.route.snapshot.url[3].toString());

    //console.log("OLD COMPONENT > selectedYear", this.selectedYear);
    //console.log("route", this.route);
    //console.log("route.snapshot", this.route.snapshot);
    //console.log("route.queryParams", this.route.queryParams);
    //console.log("router", this.router);

    this.route.queryParams.subscribe(params => {
      this.setQueryParams(params);
    });

    this.route.params.subscribe(params => {
      this.setRouteArgs(params);
    });

    this.newVersionService.getWebProjectPath().toPromise().then(path => {
      this.webProjectPath = path;
    });
  }

  setRouteArgs(params) {

    if (params) {

      //this won't work because year 2019 & 2020 is hard-coded in app-routing, so it's not in params
      if (params.year) {
        this.selectedYear = +params.year;
      }

      //but these ones will
      this.listTypeFriendlyUrl = params.listType;

      this.continentFriendlyUrl = params.continent;

      if (params.previewGuid != undefined) {
        this.previewGuid = params.previewGuid;
      }
    }

    //if (params !== undefined && params !== null && params.year !== undefined) {
    //  this.selectedYear = +params.year;

    //  this.listFriendlyUrl = params.listType;

    //  this.continentFriendlyUrl = params.continent;

    //  if (params.previewGuid != undefined) {
    //    this.previewGuid = params.previewGuid;
    //  }
    //}

    this.getContinent();
  }

  setQueryParams(params) {
    if (params['sort'] !== undefined && params['sort'] !== null) {
      var sort = params["sort"];
      if (sort == 'city') {
        this.selectedSortByFilter = 9;
      }
      else {
        var filter = this.sortByFilter.filter((o) => {
          return (o.urlValue == sort);
        })[0]

        if (!filter) {
          this.selectedSortByFilter = 10;
        }
        else {
          this.selectedSortByFilter = filter.value;
        }      
      }
      
    }

    if (params["sortByDir"] !== undefined && params['sortByDir'] !== null) {    
      this.sortByDirection == params["sortByDir"];
    }

  //  if (params["view"] !== undefined && params['sort'] !== null) {
  //    var type = params["view"];
  //    if (type === 'list') {
  //      $('.tabs__sort-view .list').closest('.tabs').find('.tab').addClass('list-view');
  //      $('.list-filters').removeClass('hidden');
  //    }      
  //  }
  //  else {
  //    $('.tabs__sort-view .list').closest('.tabs').find('.tab').removeClass('list-view');
  //    $('.list-filters').addClass('hidden');
  //  }
  }

  viewChanged(type) {
    this.router.navigate(['/lists/' + this.continentFriendlyUrl + '/' + this.listTypeFriendlyUrl + '/' + this.selectedYear],
      {
        queryParams: {
          view: type === 'list' ? type : null
        }, queryParamsHandling: 'merge'
      });
  }

  getContinent() {
    this._http.get("continent/getbyfriendlyurl/" + this.continentFriendlyUrl).toPromise().then((data) => {
      this.continent = data.json();
      //if (this.continent.name == "North America") {
      //  this.sortByFilter.push(
      //    { value: 8, displayName: "State", urlValue: 'state' },
      //  );
      //}

      this.getListType();
    }).catch();
  }


  getListType() {
    this._http.get("lists/getlisttypebyfriendlyurl/" + this.listTypeFriendlyUrl).toPromise().then((data) => {
      this.listType = data.json();
      this.getLanguages();
      this.getLists();
    }).catch();
  }

  onLanguageChange(languageId) {

    //this.router.navigate(['/lists/' + this.continentFriendlyUrl + '/' + this.listTypeFriendlyUrl + '/' + this.selectedYear],
    //  {
    //    queryParams: {
    //      lang: languageId
    //    }, queryParamsHandling: 'merge'
    //  });

    window.location.href = window.location.pathname + "?lang=" + languageId;
  }

  getLists() {

    this.lists = null;

    this._http.get("/lists/getpublishedtypesbycontinent/" + this.continent.id).toPromise().then((data ) => {

      this.listTypes = data.json().filter((x) => {
        return x.isSpeciality === this.listType.isSpeciality
      });
                              
    });

    this._http.get("lists/getAllByContinentIdAndSpeciality/" + this.continent.id + "/" + this.listType.isSpeciality).toPromise().then((data) => {
      this.lists = data.json();
      this.selectedListId = 0;
      var filteredList = this.lists.filter((o) => {
        return (o.year == this.selectedYear && o.continentId == this.continent.id
          && o.listTypeId == this.listType.id);
      });

      var listsWithinContinentAndType = this.lists.filter((o) => {
        return (o.continentId == this.continent.id
          && o.listTypeId == this.listType.id && o.isPublished);
      });

      if (listsWithinContinentAndType.length > 1) {
        this.yearFilter = [];
        for (var i = 0; i < listsWithinContinentAndType.length; i++) {
          this.yearFilter.push({ value: listsWithinContinentAndType[i].year, name: listsWithinContinentAndType[i].year.toString() });
        }

        this.yearFilter = this.yearFilter.sort((obj1, obj2) => {
          if (obj1.value > obj2.value) {
            return -1;
          }
          if (obj1.value < obj2.value) {
            return 1;
          }
          return 0;
        });
      }

      if (filteredList !== undefined && filteredList[0] !== undefined) {
        this.selectedListId = filteredList[0].id;
        this.selectedList = filteredList[0];

        //console.log("this.selectedList", this.selectedList);
      }

      this.getListRestaurants(this.selectedListId);

      setTimeout(() => {
        this.onResize(null);
      }, 5);
    }).catch();
  }

  getLanguages() {
    this._http.get("/languages").toPromise().then((data) => {
      this.languages = data.json();
      console.log(this.languages);
      this.selectedLanguage = this.languages.find((x) => { return x.selected; });
    });
  }

  onYearFilterChange(value) {
    this.selectedYear = value
    //this.getListRestaurants(this.selectedListId);
    this.router.navigate(['/lists/' + this.continentFriendlyUrl + '/' + this.listTypeFriendlyUrl + '/' + this.selectedYear]);
  }

  onSortByChange(value) {
    //if (this.selectedSortByFilter == value) {
    //  if (this.sortByDirection == "ASC") {
    //    this.sortByDirection = "DESC";
    //  }
    //  else {
    //    this.sortByDirection = "ASC";
    //  }
    //}
    //else {
    //  this.sortByDirection = "ASC";
    //}

    this.selectedSortByFilter = value;
    //this.getListRestaurants(this.selectedListId);
    if ($(".sortClose").is(":visible")) {
      $(".sortClose").click();
    }

    var url = '/lists/' + this.continentFriendlyUrl + '/' + this.listTypeFriendlyUrl + '/' + this.selectedYear;

    if (this.previewGuid != undefined && this.previewGuid != null) {
      url += "/" + this.previewGuid.toString();
    }
    

    this.router.navigate([url],
      {
        queryParams: {
          sort: this.sortByFilter.filter((o) => {
            return (o.value == this.selectedSortByFilter);
          })[0].urlValue,
          sortByDir: this.sortByDirection === "ASC" ? null : this.sortByDirection
        }, queryParamsHandling: 'merge'
      });

   
    this.sort();
    //this.getListRestaurants(this.selectedListId);
  }

  sort() {   
    //rank
    if (this.selectedSortByFilter == 1) {
      this.listRestaurants = this.listRestaurants.sort((obj1, obj2) => {
        if (obj1.rank > obj2.rank) {
          return 1;
        }
        if (obj1.rank < obj2.rank) {
          return -1;
        }
        return 0;
      });
    }

    //name
    if (this.selectedSortByFilter == 2) {
      this.listRestaurants = this.listRestaurants.sort((obj1, obj2) => {
        if (obj1.name > obj2.name) {
          return 1;
        }
        if (obj1.name < obj2.name) {
          return -1;
        }
        return 0;
      });
    }

    //chef
    if (this.selectedSortByFilter == 3) {
      this.listRestaurants = this.listRestaurants.sort((obj1, obj2) => {
        if (obj1.chef > obj2.chef) {
          return 1;
        }
        if (obj1.chef < obj2.chef) {
          return -1;
        }
        return 0;
      });
    }

    //cuisine
    if (this.selectedSortByFilter == 4) {
      this.listRestaurants = this.listRestaurants.sort((obj1, obj2) => {
        if (obj1.cuisine > obj2.cuisine) {
          return 1;
        }
        if (obj1.cuisine < obj2.cuisine) {
          return -1;
        }
        return 0;
      });
    }

    //city
    if (this.selectedSortByFilter == 6) {
      this.listRestaurants = this.listRestaurants.sort((obj1, obj2) => {
        if (obj1.city > obj2.city) {
          return 1;
        }
        if (obj1.city < obj2.city) {
          return -1;
        }

        if (obj1.rank > obj2.rank) {
          return 1;
        }
        if (obj1.rank < obj2.rank) {
          return -1;
        }
        return 0;
      });
    }   

    //country
    if (this.selectedSortByFilter == 7 || this.selectedSortByFilter == 5) {      
      this.listRestaurants = this.listRestaurants.sort((obj1, obj2) => {
        if (obj1.country > obj2.country) {
          return 1;
        }
        if (obj1.country < obj2.country) {
          return -1;
        }

        if (obj1.state > obj2.state) {
          return 1;
        }
        if (obj1.state < obj2.state) {
          return -1;
        }

        if (obj1.city > obj2.city) {
          return 1;
        }
        if (obj1.city < obj2.city) {
          return -1;
        }

        if (obj1.rank > obj2.rank) {
          return 1;
        }
        if (obj1.rank < obj2.rank) {
          return -1;
        }

        return 0;
      });
    }


    //region
    if (this.selectedSortByFilter == 8) {
      this.listRestaurants = this.listRestaurants.sort((obj1, obj2) => {
        if (obj1.state > obj2.state) {
          return 1;
        }
        if (obj1.state < obj2.state) {
          return -1;
        }

        if (obj1.rank > obj2.rank) {
          return 1;
        }
        if (obj1.rank < obj2.rank) {
          return -1;
        }
        return 0;
      });
    }


    //location1
    if (this.selectedSortByFilter == 9) {
      this.listRestaurants = this.listRestaurants.sort((obj1, obj2) => {
        if (obj1.location1 > obj2.location1) {
          return 1;
        }
        if (obj1.location1 < obj2.location1) {
          return -1;
        }

        if (obj1.rank > obj2.rank) {
          return 1;
        }
        if (obj1.rank < obj2.rank) {
          return -1;
        }
        return 0;
      });
    }

    //location2
    if (this.selectedSortByFilter == 10) {
      this.listRestaurants = this.listRestaurants.sort((obj1, obj2) => {
        if (obj1.location2 > obj2.location2) {
          return 1;
        }
        if (obj1.location2 < obj2.location2) {
          return -1;
        }

        if (obj1.rank > obj2.rank) {
          return 1;
        }
        if (obj1.rank < obj2.rank) {
          return -1;
        }
        return 0;
      });
    }
  }

  listTypeChange(friendlyUrl) {
    this.listTypeFriendlyUrl = friendlyUrl;
    this.router.navigate(['/lists/' + this.continentFriendlyUrl + '/' + this.listTypeFriendlyUrl + '/' + this.selectedYear]);
  }

  getListRestaurants(id) {
    this.selectedListId = id;
    this.listRestaurants = null;
    var postData = {
      ListId: this.selectedListId,
      Year: this.selectedYear,
      SortByDirection: this.sortByDirection,
      SortBy: this.selectedSortByFilter,
      PreviewGuid: this.previewGuid
    }

    if (this.selectedListId !== 0) {
      this._http.post("/lists/getrestaurantsbylistIdAndYear", JSON.stringify(postData), { headers: new Headers({ 'Content-Type': 'application/json' }) }).toPromise()
        .then((data) => {
          this.data = data.json();
          this.listRestaurants = this.data.data0;

          //console.log("listRestaurants[0]", this.listRestaurants[0]);

          this.sortByFilter.push(
            { value: 9, displayName: this.data.location1, urlValue: this.data.location1.replace(" ", "").replace(" ", "").replace("/", "-").toLowerCase() },
            { value: 10, displayName: this.data.location2, urlValue: this.data.location2.replace(" ", "").replace(" ", "").replace("/", "-").toLowerCase() },
          );
        }).catch();
    }
    else {
      this.listRestaurants = [];
    }
  }

  getRestaurantUrl(friendlyUrl: string): string {
    //return `${this.webProjectPath}restaurant/${friendlyUrl}`;
    return `/restaurant/${friendlyUrl}`;
  }
}
